import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import React from 'react';

import logo from '../assets/lio-logo.png';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const Login = () => {

	const { loginWithPopup } = useAuth0();
	const navigate = useNavigate();

	const handleNeedMigration = () => {
		navigate('/usermigration');
	}

	return (
		<>
			<div className='m-4'>
				<div className='row'>
					<Container className='align-items-center login-container'>
						<Row className='mt-3 justify-content-center align-items-center'>
							<Image className='login-logo' src={logo} alt={'logo'} />
							<><Button
								className="btn-brand btn-height mt-4"
								onClick={() => {
									loginWithPopup();
								}}
							>
								Log in
							</Button>
								<Col md="auto">
									<Row className="justify-content-md-center text-center mt-4"><a href="https://support.languageio.com/hc/en-us/articles/8812712733453-Installing-the-Language-I-O-Chrome-extension#01J35P9EWPR6YCQ6J1ZPW8KSKA" target="_blank">
										<strong>
											Need an account?
										</strong></a>
									</Row>
									<Row className="justify-content-md-center text-center mt-4"><a href="#" onClick={handleNeedMigration}>
										<strong>
											Migrate account
										</strong></a>
									</Row>
									<Row className="justify-content-md-center text-center mt-4"><a href="https://support.languageio.com/hc/en-us/articles/12979490397325-Using-the-Language-I-O-Chrome-Extension" target="_blank">
										<strong>
											FAQ's
										</strong></a>
									</Row>
									<Row className="justify-content-md-center text-center mt-4"><a href="https://languageio.com" target="_blank">
										<strong>
											Learn more about Language I/O
										</strong></a>
									</Row>
								</Col>

							</>
						</Row>
					</Container>
				</div>
			</div>
		</>
	);
};

export default Login;
